<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 20">
    <path
      d="M19.2017 1H2.354C1.48352 1 0.777832 1.67657 0.777832 2.51114V14.9365C0.777832 15.7711 1.48352 16.4477 2.354 16.4477H10.4968V18.4571H5.59507C5.43872 18.4571 5.31195 18.5787 5.31195 18.7286C5.31195 18.8785 5.43872 19 5.59507 19H15.9606C16.1169 19 16.2437 18.8785 16.2437 18.7286C16.2437 18.5787 16.1169 18.4571 15.9606 18.4571H11.0588V16.4477H19.2017C20.0721 16.4477 20.7778 15.7711 20.7778 14.9365V2.51114C20.7778 1.67657 20.0721 1 19.2017 1ZM20.2158 14.9365C20.2158 15.4713 19.7594 15.9088 19.2017 15.9088H2.354C1.79621 15.9088 1.33984 15.4713 1.33984 14.9365V14.183H20.2158V14.9365Z"
      :class="colorClass"
      stroke-width="0.4"
    />
    <path
      d="M7.77124 6.78934L8.21493 7.20257L10.4672 4.97435V11.3673H11.0884V4.97435L13.3449 7.20257L13.7886 6.78934L10.7799 3.81567L7.77124 6.78934Z"
      fill="white"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
